// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vd__2HOYc","imageWrapper":"vd__1eDQg","title":"vd__1EtcP","description":"vd__3nSJr","footer":"vd__2e6iw"};